/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}    from '@/models/action';
import {Logger}                from '@/util/logger';
import {WindowService}         from "@/services/window.service";
import {FileBrowserMetadata}   from '@/screens/ide/file.browser.metadata';

/**
 *
 * @class WindowFileBrowserAction
 *
 * @brief launch a fresh blob explorer tab
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class WindowFileBrowserAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.filebrowser',
      type:  ActionType.Window_FileBrowser,
      label: 'Browse',
      icon:  '<i class="far fa-eye"></i>',
      tip:   'Launch a new file exploring tab'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[WindowFileBrowserAction] executing...');

    this.windows.launchWindow(new FileBrowserMetadata(
      '', '<strong>/</strong>',  '/'
    ));

    return true;
  }
}
